// Autogenerated by timezone:generate Command
export default [
    {
        "name": "[GMT-11:00] Pacific/Pago Pago",
        "value": "Pacific/Pago_Pago"
    },
    {
        "name": "[GMT-11:00] Pacific/Niue",
        "value": "Pacific/Niue"
    },
    {
        "name": "[GMT-11:00] Pacific/Midway",
        "value": "Pacific/Midway"
    },
    {
        "name": "[GMT-10:30] Pacific/Marquesas",
        "value": "Pacific/Marquesas"
    },
    {
        "name": "[GMT-10:00] Pacific/Tahiti",
        "value": "Pacific/Tahiti"
    },
    {
        "name": "[GMT-10:00] Pacific/Rarotonga",
        "value": "Pacific/Rarotonga"
    },
    {
        "name": "[GMT-10:00] Pacific/Honolulu",
        "value": "Pacific/Honolulu"
    },
    {
        "name": "[GMT-10:00] America/Adak",
        "value": "America/Adak"
    },
    {
        "name": "[GMT-09:00] Pacific/Gambier",
        "value": "Pacific/Gambier"
    },
    {
        "name": "[GMT-09:00] America/Yakutat",
        "value": "America/Yakutat"
    },
    {
        "name": "[GMT-09:00] America/Sitka",
        "value": "America/Sitka"
    },
    {
        "name": "[GMT-09:00] America/Nome",
        "value": "America/Nome"
    },
    {
        "name": "[GMT-09:00] America/Metlakatla",
        "value": "America/Metlakatla"
    },
    {
        "name": "[GMT-09:00] America/Juneau",
        "value": "America/Juneau"
    },
    {
        "name": "[GMT-09:00] America/Anchorage",
        "value": "America/Anchorage"
    },
    {
        "name": "[GMT-08:00] Pacific/Pitcairn",
        "value": "Pacific/Pitcairn"
    },
    {
        "name": "[GMT-08:00] America/Vancouver",
        "value": "America/Vancouver"
    },
    {
        "name": "[GMT-08:00] America/Tijuana",
        "value": "America/Tijuana"
    },
    {
        "name": "[GMT-08:00] America/Los Angeles",
        "value": "America/Los_Angeles"
    },
    {
        "name": "[GMT-07:00] America/Yellowknife",
        "value": "America/Yellowknife"
    },
    {
        "name": "[GMT-07:00] America/Whitehorse",
        "value": "America/Whitehorse"
    },
    {
        "name": "[GMT-07:00] America/Phoenix",
        "value": "America/Phoenix"
    },
    {
        "name": "[GMT-07:00] America/Ojinaga",
        "value": "America/Ojinaga"
    },
    {
        "name": "[GMT-07:00] America/Mazatlan",
        "value": "America/Mazatlan"
    },
    {
        "name": "[GMT-07:00] America/Inuvik",
        "value": "America/Inuvik"
    },
    {
        "name": "[GMT-07:00] America/Hermosillo",
        "value": "America/Hermosillo"
    },
    {
        "name": "[GMT-07:00] America/Fort Nelson",
        "value": "America/Fort_Nelson"
    },
    {
        "name": "[GMT-07:00] America/Edmonton",
        "value": "America/Edmonton"
    },
    {
        "name": "[GMT-07:00] America/Denver",
        "value": "America/Denver"
    },
    {
        "name": "[GMT-07:00] America/Dawson Creek",
        "value": "America/Dawson_Creek"
    },
    {
        "name": "[GMT-07:00] America/Dawson",
        "value": "America/Dawson"
    },
    {
        "name": "[GMT-07:00] America/Creston",
        "value": "America/Creston"
    },
    {
        "name": "[GMT-07:00] America/Chihuahua",
        "value": "America/Chihuahua"
    },
    {
        "name": "[GMT-07:00] America/Cambridge Bay",
        "value": "America/Cambridge_Bay"
    },
    {
        "name": "[GMT-07:00] America/Boise",
        "value": "America/Boise"
    },
    {
        "name": "[GMT-06:00] Pacific/Galapagos",
        "value": "Pacific/Galapagos"
    },
    {
        "name": "[GMT-06:00] America/Winnipeg",
        "value": "America/Winnipeg"
    },
    {
        "name": "[GMT-06:00] America/Tegucigalpa",
        "value": "America/Tegucigalpa"
    },
    {
        "name": "[GMT-06:00] America/Swift Current",
        "value": "America/Swift_Current"
    },
    {
        "name": "[GMT-06:00] America/Resolute",
        "value": "America/Resolute"
    },
    {
        "name": "[GMT-06:00] America/Regina",
        "value": "America/Regina"
    },
    {
        "name": "[GMT-06:00] America/Rankin Inlet",
        "value": "America/Rankin_Inlet"
    },
    {
        "name": "[GMT-06:00] America/Rainy River",
        "value": "America/Rainy_River"
    },
    {
        "name": "[GMT-06:00] America/North Dakota (New Salem)",
        "value": "America/North_Dakota/New_Salem"
    },
    {
        "name": "[GMT-06:00] America/North Dakota (Center)",
        "value": "America/North_Dakota/Center"
    },
    {
        "name": "[GMT-06:00] America/North Dakota (Beulah)",
        "value": "America/North_Dakota/Beulah"
    },
    {
        "name": "[GMT-06:00] America/Monterrey",
        "value": "America/Monterrey"
    },
    {
        "name": "[GMT-06:00] America/Mexico City",
        "value": "America/Mexico_City"
    },
    {
        "name": "[GMT-06:00] America/Merida",
        "value": "America/Merida"
    },
    {
        "name": "[GMT-06:00] America/Menominee",
        "value": "America/Menominee"
    },
    {
        "name": "[GMT-06:00] America/Matamoros",
        "value": "America/Matamoros"
    },
    {
        "name": "[GMT-06:00] America/Managua",
        "value": "America/Managua"
    },
    {
        "name": "[GMT-06:00] America/Indiana (Tell City)",
        "value": "America/Indiana/Tell_City"
    },
    {
        "name": "[GMT-06:00] America/Indiana (Knox)",
        "value": "America/Indiana/Knox"
    },
    {
        "name": "[GMT-06:00] America/Guatemala",
        "value": "America/Guatemala"
    },
    {
        "name": "[GMT-06:00] America/El Salvador",
        "value": "America/El_Salvador"
    },
    {
        "name": "[GMT-06:00] America/Costa Rica",
        "value": "America/Costa_Rica"
    },
    {
        "name": "[GMT-06:00] America/Chicago",
        "value": "America/Chicago"
    },
    {
        "name": "[GMT-06:00] America/Belize",
        "value": "America/Belize"
    },
    {
        "name": "[GMT-06:00] America/Bahia Banderas",
        "value": "America/Bahia_Banderas"
    },
    {
        "name": "[GMT-05:00] Pacific/Easter",
        "value": "Pacific/Easter"
    },
    {
        "name": "[GMT-05:00] America/Toronto",
        "value": "America/Toronto"
    },
    {
        "name": "[GMT-05:00] America/Thunder Bay",
        "value": "America/Thunder_Bay"
    },
    {
        "name": "[GMT-05:00] America/Rio Branco",
        "value": "America/Rio_Branco"
    },
    {
        "name": "[GMT-05:00] America/Port-au-Prince",
        "value": "America/Port-au-Prince"
    },
    {
        "name": "[GMT-05:00] America/Pangnirtung",
        "value": "America/Pangnirtung"
    },
    {
        "name": "[GMT-05:00] America/Panama",
        "value": "America/Panama"
    },
    {
        "name": "[GMT-05:00] America/Nipigon",
        "value": "America/Nipigon"
    },
    {
        "name": "[GMT-05:00] America/New York",
        "value": "America/New_York"
    },
    {
        "name": "[GMT-05:00] America/Nassau",
        "value": "America/Nassau"
    },
    {
        "name": "[GMT-05:00] America/Lima",
        "value": "America/Lima"
    },
    {
        "name": "[GMT-05:00] America/Kentucky (Monticello)",
        "value": "America/Kentucky/Monticello"
    },
    {
        "name": "[GMT-05:00] America/Kentucky (Louisville)",
        "value": "America/Kentucky/Louisville"
    },
    {
        "name": "[GMT-05:00] America/Jamaica",
        "value": "America/Jamaica"
    },
    {
        "name": "[GMT-05:00] America/Iqaluit",
        "value": "America/Iqaluit"
    },
    {
        "name": "[GMT-05:00] America/Indiana (Winamac)",
        "value": "America/Indiana/Winamac"
    },
    {
        "name": "[GMT-05:00] America/Indiana (Vincennes)",
        "value": "America/Indiana/Vincennes"
    },
    {
        "name": "[GMT-05:00] America/Indiana (Vevay)",
        "value": "America/Indiana/Vevay"
    },
    {
        "name": "[GMT-05:00] America/Indiana (Petersburg)",
        "value": "America/Indiana/Petersburg"
    },
    {
        "name": "[GMT-05:00] America/Indiana (Marengo)",
        "value": "America/Indiana/Marengo"
    },
    {
        "name": "[GMT-05:00] America/Indiana (Indianapolis)",
        "value": "America/Indiana/Indianapolis"
    },
    {
        "name": "[GMT-05:00] America/Havana",
        "value": "America/Havana"
    },
    {
        "name": "[GMT-05:00] America/Guayaquil",
        "value": "America/Guayaquil"
    },
    {
        "name": "[GMT-05:00] America/Grand Turk",
        "value": "America/Grand_Turk"
    },
    {
        "name": "[GMT-05:00] America/Eirunepe",
        "value": "America/Eirunepe"
    },
    {
        "name": "[GMT-05:00] America/Detroit",
        "value": "America/Detroit"
    },
    {
        "name": "[GMT-05:00] America/Cayman",
        "value": "America/Cayman"
    },
    {
        "name": "[GMT-05:00] America/Cancun",
        "value": "America/Cancun"
    },
    {
        "name": "[GMT-05:00] America/Bogota",
        "value": "America/Bogota"
    },
    {
        "name": "[GMT-05:00] America/Atikokan",
        "value": "America/Atikokan"
    },
    {
        "name": "[GMT-04:30] America/St Johns",
        "value": "America/St_Johns"
    },
    {
        "name": "[GMT-04:00] Atlantic/Bermuda",
        "value": "Atlantic/Bermuda"
    },
    {
        "name": "[GMT-04:00] America/Tortola",
        "value": "America/Tortola"
    },
    {
        "name": "[GMT-04:00] America/Thule",
        "value": "America/Thule"
    },
    {
        "name": "[GMT-04:00] America/St Vincent",
        "value": "America/St_Vincent"
    },
    {
        "name": "[GMT-04:00] America/St Thomas",
        "value": "America/St_Thomas"
    },
    {
        "name": "[GMT-04:00] America/St Lucia",
        "value": "America/St_Lucia"
    },
    {
        "name": "[GMT-04:00] America/St Kitts",
        "value": "America/St_Kitts"
    },
    {
        "name": "[GMT-04:00] America/St Barthelemy",
        "value": "America/St_Barthelemy"
    },
    {
        "name": "[GMT-04:00] America/Santo Domingo",
        "value": "America/Santo_Domingo"
    },
    {
        "name": "[GMT-04:00] America/Puerto Rico",
        "value": "America/Puerto_Rico"
    },
    {
        "name": "[GMT-04:00] America/Porto Velho",
        "value": "America/Porto_Velho"
    },
    {
        "name": "[GMT-04:00] America/Port of Spain",
        "value": "America/Port_of_Spain"
    },
    {
        "name": "[GMT-04:00] America/Montserrat",
        "value": "America/Montserrat"
    },
    {
        "name": "[GMT-04:00] America/Moncton",
        "value": "America/Moncton"
    },
    {
        "name": "[GMT-04:00] America/Martinique",
        "value": "America/Martinique"
    },
    {
        "name": "[GMT-04:00] America/Marigot",
        "value": "America/Marigot"
    },
    {
        "name": "[GMT-04:00] America/Manaus",
        "value": "America/Manaus"
    },
    {
        "name": "[GMT-04:00] America/Lower Princes",
        "value": "America/Lower_Princes"
    },
    {
        "name": "[GMT-04:00] America/La Paz",
        "value": "America/La_Paz"
    },
    {
        "name": "[GMT-04:00] America/Kralendijk",
        "value": "America/Kralendijk"
    },
    {
        "name": "[GMT-04:00] America/Halifax",
        "value": "America/Halifax"
    },
    {
        "name": "[GMT-04:00] America/Guyana",
        "value": "America/Guyana"
    },
    {
        "name": "[GMT-04:00] America/Guadeloupe",
        "value": "America/Guadeloupe"
    },
    {
        "name": "[GMT-04:00] America/Grenada",
        "value": "America/Grenada"
    },
    {
        "name": "[GMT-04:00] America/Goose Bay",
        "value": "America/Goose_Bay"
    },
    {
        "name": "[GMT-04:00] America/Glace Bay",
        "value": "America/Glace_Bay"
    },
    {
        "name": "[GMT-04:00] America/Dominica",
        "value": "America/Dominica"
    },
    {
        "name": "[GMT-04:00] America/Curacao",
        "value": "America/Curacao"
    },
    {
        "name": "[GMT-04:00] America/Cuiaba",
        "value": "America/Cuiaba"
    },
    {
        "name": "[GMT-04:00] America/Caracas",
        "value": "America/Caracas"
    },
    {
        "name": "[GMT-04:00] America/Campo Grande",
        "value": "America/Campo_Grande"
    },
    {
        "name": "[GMT-04:00] America/Boa Vista",
        "value": "America/Boa_Vista"
    },
    {
        "name": "[GMT-04:00] America/Blanc-Sablon",
        "value": "America/Blanc-Sablon"
    },
    {
        "name": "[GMT-04:00] America/Barbados",
        "value": "America/Barbados"
    },
    {
        "name": "[GMT-04:00] America/Aruba",
        "value": "America/Aruba"
    },
    {
        "name": "[GMT-04:00] America/Antigua",
        "value": "America/Antigua"
    },
    {
        "name": "[GMT-04:00] America/Anguilla",
        "value": "America/Anguilla"
    },
    {
        "name": "[GMT-03:00] Atlantic/Stanley",
        "value": "Atlantic/Stanley"
    },
    {
        "name": "[GMT-03:00] Antarctica/Rothera",
        "value": "Antarctica/Rothera"
    },
    {
        "name": "[GMT-03:00] Antarctica/Palmer",
        "value": "Antarctica/Palmer"
    },
    {
        "name": "[GMT-03:00] America/Sao Paulo",
        "value": "America/Sao_Paulo"
    },
    {
        "name": "[GMT-03:00] America/Santiago",
        "value": "America/Santiago"
    },
    {
        "name": "[GMT-03:00] America/Santarem",
        "value": "America/Santarem"
    },
    {
        "name": "[GMT-03:00] America/Recife",
        "value": "America/Recife"
    },
    {
        "name": "[GMT-03:00] America/Punta Arenas",
        "value": "America/Punta_Arenas"
    },
    {
        "name": "[GMT-03:00] America/Paramaribo",
        "value": "America/Paramaribo"
    },
    {
        "name": "[GMT-03:00] America/Nuuk",
        "value": "America/Nuuk"
    },
    {
        "name": "[GMT-03:00] America/Montevideo",
        "value": "America/Montevideo"
    },
    {
        "name": "[GMT-03:00] America/Miquelon",
        "value": "America/Miquelon"
    },
    {
        "name": "[GMT-03:00] America/Maceio",
        "value": "America/Maceio"
    },
    {
        "name": "[GMT-03:00] America/Fortaleza",
        "value": "America/Fortaleza"
    },
    {
        "name": "[GMT-03:00] America/Cayenne",
        "value": "America/Cayenne"
    },
    {
        "name": "[GMT-03:00] America/Belem",
        "value": "America/Belem"
    },
    {
        "name": "[GMT-03:00] America/Bahia",
        "value": "America/Bahia"
    },
    {
        "name": "[GMT-03:00] America/Asuncion",
        "value": "America/Asuncion"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Ushuaia)",
        "value": "America/Argentina/Ushuaia"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Tucuman)",
        "value": "America/Argentina/Tucuman"
    },
    {
        "name": "[GMT-03:00] America/Argentina (San Luis)",
        "value": "America/Argentina/San_Luis"
    },
    {
        "name": "[GMT-03:00] America/Argentina (San Juan)",
        "value": "America/Argentina/San_Juan"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Salta)",
        "value": "America/Argentina/Salta"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Rio Gallegos)",
        "value": "America/Argentina/Rio_Gallegos"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Mendoza)",
        "value": "America/Argentina/Mendoza"
    },
    {
        "name": "[GMT-03:00] America/Argentina (La Rioja)",
        "value": "America/Argentina/La_Rioja"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Jujuy)",
        "value": "America/Argentina/Jujuy"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Cordoba)",
        "value": "America/Argentina/Cordoba"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Catamarca)",
        "value": "America/Argentina/Catamarca"
    },
    {
        "name": "[GMT-03:00] America/Argentina (Buenos Aires)",
        "value": "America/Argentina/Buenos_Aires"
    },
    {
        "name": "[GMT-03:00] America/Araguaina",
        "value": "America/Araguaina"
    },
    {
        "name": "[GMT-02:00] Atlantic/South Georgia",
        "value": "Atlantic/South_Georgia"
    },
    {
        "name": "[GMT-02:00] America/Noronha",
        "value": "America/Noronha"
    },
    {
        "name": "[GMT-01:00] Atlantic/Cape Verde",
        "value": "Atlantic/Cape_Verde"
    },
    {
        "name": "[GMT-01:00] Atlantic/Azores",
        "value": "Atlantic/Azores"
    },
    {
        "name": "[GMT-01:00] America/Scoresbysund",
        "value": "America/Scoresbysund"
    },
    {
        "name": "[GMT] Africa/Abidjan",
        "value": "Africa/Abidjan"
    },
    {
        "name": "[GMT] Africa/Accra",
        "value": "Africa/Accra"
    },
    {
        "name": "[GMT] Africa/Bamako",
        "value": "Africa/Bamako"
    },
    {
        "name": "[GMT] Africa/Banjul",
        "value": "Africa/Banjul"
    },
    {
        "name": "[GMT] Africa/Bissau",
        "value": "Africa/Bissau"
    },
    {
        "name": "[GMT] Africa/Conakry",
        "value": "Africa/Conakry"
    },
    {
        "name": "[GMT] Africa/Dakar",
        "value": "Africa/Dakar"
    },
    {
        "name": "[GMT] Africa/Freetown",
        "value": "Africa/Freetown"
    },
    {
        "name": "[GMT] Africa/Lome",
        "value": "Africa/Lome"
    },
    {
        "name": "[GMT] Africa/Monrovia",
        "value": "Africa/Monrovia"
    },
    {
        "name": "[GMT] Africa/Nouakchott",
        "value": "Africa/Nouakchott"
    },
    {
        "name": "[GMT] Africa/Ouagadougou",
        "value": "Africa/Ouagadougou"
    },
    {
        "name": "[GMT] Africa/Sao Tome",
        "value": "Africa/Sao_Tome"
    },
    {
        "name": "[GMT] America/Danmarkshavn",
        "value": "America/Danmarkshavn"
    },
    {
        "name": "[GMT] Antarctica/Troll",
        "value": "Antarctica/Troll"
    },
    {
        "name": "[GMT] Atlantic/Canary",
        "value": "Atlantic/Canary"
    },
    {
        "name": "[GMT] Atlantic/Faroe",
        "value": "Atlantic/Faroe"
    },
    {
        "name": "[GMT] Atlantic/Madeira",
        "value": "Atlantic/Madeira"
    },
    {
        "name": "[GMT] Atlantic/Reykjavik",
        "value": "Atlantic/Reykjavik"
    },
    {
        "name": "[GMT] Atlantic/St Helena",
        "value": "Atlantic/St_Helena"
    },
    {
        "name": "[GMT] Europe/Dublin",
        "value": "Europe/Dublin"
    },
    {
        "name": "[GMT] Europe/Guernsey",
        "value": "Europe/Guernsey"
    },
    {
        "name": "[GMT] Europe/Isle of Man",
        "value": "Europe/Isle_of_Man"
    },
    {
        "name": "[GMT] Europe/Jersey",
        "value": "Europe/Jersey"
    },
    {
        "name": "[GMT] Europe/Lisbon",
        "value": "Europe/Lisbon"
    },
    {
        "name": "[GMT] Europe/London",
        "value": "Europe/London"
    },
    {
        "name": "[GMT] UTC",
        "value": "UTC"
    },
    {
        "name": "[GMT+01:00] Africa/Algiers",
        "value": "Africa/Algiers"
    },
    {
        "name": "[GMT+01:00] Africa/Bangui",
        "value": "Africa/Bangui"
    },
    {
        "name": "[GMT+01:00] Africa/Brazzaville",
        "value": "Africa/Brazzaville"
    },
    {
        "name": "[GMT+01:00] Africa/Casablanca",
        "value": "Africa/Casablanca"
    },
    {
        "name": "[GMT+01:00] Africa/Ceuta",
        "value": "Africa/Ceuta"
    },
    {
        "name": "[GMT+01:00] Africa/Douala",
        "value": "Africa/Douala"
    },
    {
        "name": "[GMT+01:00] Africa/El Aaiun",
        "value": "Africa/El_Aaiun"
    },
    {
        "name": "[GMT+01:00] Africa/Kinshasa",
        "value": "Africa/Kinshasa"
    },
    {
        "name": "[GMT+01:00] Africa/Lagos",
        "value": "Africa/Lagos"
    },
    {
        "name": "[GMT+01:00] Africa/Libreville",
        "value": "Africa/Libreville"
    },
    {
        "name": "[GMT+01:00] Africa/Luanda",
        "value": "Africa/Luanda"
    },
    {
        "name": "[GMT+01:00] Africa/Malabo",
        "value": "Africa/Malabo"
    },
    {
        "name": "[GMT+01:00] Africa/Ndjamena",
        "value": "Africa/Ndjamena"
    },
    {
        "name": "[GMT+01:00] Africa/Niamey",
        "value": "Africa/Niamey"
    },
    {
        "name": "[GMT+01:00] Africa/Porto-Novo",
        "value": "Africa/Porto-Novo"
    },
    {
        "name": "[GMT+01:00] Africa/Tunis",
        "value": "Africa/Tunis"
    },
    {
        "name": "[GMT+01:00] Arctic/Longyearbyen",
        "value": "Arctic/Longyearbyen"
    },
    {
        "name": "[GMT+01:00] Europe/Amsterdam",
        "value": "Europe/Amsterdam"
    },
    {
        "name": "[GMT+01:00] Europe/Andorra",
        "value": "Europe/Andorra"
    },
    {
        "name": "[GMT+01:00] Europe/Belgrade",
        "value": "Europe/Belgrade"
    },
    {
        "name": "[GMT+01:00] Europe/Berlin",
        "value": "Europe/Berlin"
    },
    {
        "name": "[GMT+01:00] Europe/Bratislava",
        "value": "Europe/Bratislava"
    },
    {
        "name": "[GMT+01:00] Europe/Brussels",
        "value": "Europe/Brussels"
    },
    {
        "name": "[GMT+01:00] Europe/Budapest",
        "value": "Europe/Budapest"
    },
    {
        "name": "[GMT+01:00] Europe/Busingen",
        "value": "Europe/Busingen"
    },
    {
        "name": "[GMT+01:00] Europe/Copenhagen",
        "value": "Europe/Copenhagen"
    },
    {
        "name": "[GMT+01:00] Europe/Gibraltar",
        "value": "Europe/Gibraltar"
    },
    {
        "name": "[GMT+01:00] Europe/Ljubljana",
        "value": "Europe/Ljubljana"
    },
    {
        "name": "[GMT+01:00] Europe/Luxembourg",
        "value": "Europe/Luxembourg"
    },
    {
        "name": "[GMT+01:00] Europe/Madrid",
        "value": "Europe/Madrid"
    },
    {
        "name": "[GMT+01:00] Europe/Malta",
        "value": "Europe/Malta"
    },
    {
        "name": "[GMT+01:00] Europe/Monaco",
        "value": "Europe/Monaco"
    },
    {
        "name": "[GMT+01:00] Europe/Oslo",
        "value": "Europe/Oslo"
    },
    {
        "name": "[GMT+01:00] Europe/Paris",
        "value": "Europe/Paris"
    },
    {
        "name": "[GMT+01:00] Europe/Podgorica",
        "value": "Europe/Podgorica"
    },
    {
        "name": "[GMT+01:00] Europe/Prague",
        "value": "Europe/Prague"
    },
    {
        "name": "[GMT+01:00] Europe/Rome",
        "value": "Europe/Rome"
    },
    {
        "name": "[GMT+01:00] Europe/San Marino",
        "value": "Europe/San_Marino"
    },
    {
        "name": "[GMT+01:00] Europe/Sarajevo",
        "value": "Europe/Sarajevo"
    },
    {
        "name": "[GMT+01:00] Europe/Skopje",
        "value": "Europe/Skopje"
    },
    {
        "name": "[GMT+01:00] Europe/Stockholm",
        "value": "Europe/Stockholm"
    },
    {
        "name": "[GMT+01:00] Europe/Tirane",
        "value": "Europe/Tirane"
    },
    {
        "name": "[GMT+01:00] Europe/Vaduz",
        "value": "Europe/Vaduz"
    },
    {
        "name": "[GMT+01:00] Europe/Vatican",
        "value": "Europe/Vatican"
    },
    {
        "name": "[GMT+01:00] Europe/Vienna",
        "value": "Europe/Vienna"
    },
    {
        "name": "[GMT+01:00] Europe/Warsaw",
        "value": "Europe/Warsaw"
    },
    {
        "name": "[GMT+01:00] Europe/Zagreb",
        "value": "Europe/Zagreb"
    },
    {
        "name": "[GMT+01:00] Europe/Zurich",
        "value": "Europe/Zurich"
    },
    {
        "name": "[GMT+02:00] Africa/Blantyre",
        "value": "Africa/Blantyre"
    },
    {
        "name": "[GMT+02:00] Africa/Bujumbura",
        "value": "Africa/Bujumbura"
    },
    {
        "name": "[GMT+02:00] Africa/Cairo",
        "value": "Africa/Cairo"
    },
    {
        "name": "[GMT+02:00] Africa/Gaborone",
        "value": "Africa/Gaborone"
    },
    {
        "name": "[GMT+02:00] Africa/Harare",
        "value": "Africa/Harare"
    },
    {
        "name": "[GMT+02:00] Africa/Johannesburg",
        "value": "Africa/Johannesburg"
    },
    {
        "name": "[GMT+02:00] Africa/Juba",
        "value": "Africa/Juba"
    },
    {
        "name": "[GMT+02:00] Africa/Khartoum",
        "value": "Africa/Khartoum"
    },
    {
        "name": "[GMT+02:00] Africa/Kigali",
        "value": "Africa/Kigali"
    },
    {
        "name": "[GMT+02:00] Africa/Lubumbashi",
        "value": "Africa/Lubumbashi"
    },
    {
        "name": "[GMT+02:00] Africa/Lusaka",
        "value": "Africa/Lusaka"
    },
    {
        "name": "[GMT+02:00] Africa/Maputo",
        "value": "Africa/Maputo"
    },
    {
        "name": "[GMT+02:00] Africa/Maseru",
        "value": "Africa/Maseru"
    },
    {
        "name": "[GMT+02:00] Africa/Mbabane",
        "value": "Africa/Mbabane"
    },
    {
        "name": "[GMT+02:00] Africa/Tripoli",
        "value": "Africa/Tripoli"
    },
    {
        "name": "[GMT+02:00] Africa/Windhoek",
        "value": "Africa/Windhoek"
    },
    {
        "name": "[GMT+02:00] Asia/Amman",
        "value": "Asia/Amman"
    },
    {
        "name": "[GMT+02:00] Asia/Beirut",
        "value": "Asia/Beirut"
    },
    {
        "name": "[GMT+02:00] Asia/Damascus",
        "value": "Asia/Damascus"
    },
    {
        "name": "[GMT+02:00] Asia/Famagusta",
        "value": "Asia/Famagusta"
    },
    {
        "name": "[GMT+02:00] Asia/Gaza",
        "value": "Asia/Gaza"
    },
    {
        "name": "[GMT+02:00] Asia/Hebron",
        "value": "Asia/Hebron"
    },
    {
        "name": "[GMT+02:00] Asia/Jerusalem",
        "value": "Asia/Jerusalem"
    },
    {
        "name": "[GMT+02:00] Asia/Nicosia",
        "value": "Asia/Nicosia"
    },
    {
        "name": "[GMT+02:00] Europe/Athens",
        "value": "Europe/Athens"
    },
    {
        "name": "[GMT+02:00] Europe/Bucharest",
        "value": "Europe/Bucharest"
    },
    {
        "name": "[GMT+02:00] Europe/Chisinau",
        "value": "Europe/Chisinau"
    },
    {
        "name": "[GMT+02:00] Europe/Helsinki",
        "value": "Europe/Helsinki"
    },
    {
        "name": "[GMT+02:00] Europe/Kaliningrad",
        "value": "Europe/Kaliningrad"
    },
    {
        "name": "[GMT+02:00] Europe/Kiev",
        "value": "Europe/Kiev"
    },
    {
        "name": "[GMT+02:00] Europe/Mariehamn",
        "value": "Europe/Mariehamn"
    },
    {
        "name": "[GMT+02:00] Europe/Riga",
        "value": "Europe/Riga"
    },
    {
        "name": "[GMT+02:00] Europe/Sofia",
        "value": "Europe/Sofia"
    },
    {
        "name": "[GMT+02:00] Europe/Tallinn",
        "value": "Europe/Tallinn"
    },
    {
        "name": "[GMT+02:00] Europe/Uzhgorod",
        "value": "Europe/Uzhgorod"
    },
    {
        "name": "[GMT+02:00] Europe/Vilnius",
        "value": "Europe/Vilnius"
    },
    {
        "name": "[GMT+02:00] Europe/Zaporozhye",
        "value": "Europe/Zaporozhye"
    },
    {
        "name": "[GMT+03:00] Africa/Addis Ababa",
        "value": "Africa/Addis_Ababa"
    },
    {
        "name": "[GMT+03:00] Africa/Asmara",
        "value": "Africa/Asmara"
    },
    {
        "name": "[GMT+03:00] Africa/Dar es Salaam",
        "value": "Africa/Dar_es_Salaam"
    },
    {
        "name": "[GMT+03:00] Africa/Djibouti",
        "value": "Africa/Djibouti"
    },
    {
        "name": "[GMT+03:00] Africa/Kampala",
        "value": "Africa/Kampala"
    },
    {
        "name": "[GMT+03:00] Africa/Mogadishu",
        "value": "Africa/Mogadishu"
    },
    {
        "name": "[GMT+03:00] Africa/Nairobi",
        "value": "Africa/Nairobi"
    },
    {
        "name": "[GMT+03:00] Antarctica/Syowa",
        "value": "Antarctica/Syowa"
    },
    {
        "name": "[GMT+03:00] Asia/Aden",
        "value": "Asia/Aden"
    },
    {
        "name": "[GMT+03:00] Asia/Baghdad",
        "value": "Asia/Baghdad"
    },
    {
        "name": "[GMT+03:00] Asia/Bahrain",
        "value": "Asia/Bahrain"
    },
    {
        "name": "[GMT+03:00] Asia/Kuwait",
        "value": "Asia/Kuwait"
    },
    {
        "name": "[GMT+03:00] Asia/Qatar",
        "value": "Asia/Qatar"
    },
    {
        "name": "[GMT+03:00] Asia/Riyadh",
        "value": "Asia/Riyadh"
    },
    {
        "name": "[GMT+03:00] Europe/Istanbul",
        "value": "Europe/Istanbul"
    },
    {
        "name": "[GMT+03:00] Europe/Kirov",
        "value": "Europe/Kirov"
    },
    {
        "name": "[GMT+03:00] Europe/Minsk",
        "value": "Europe/Minsk"
    },
    {
        "name": "[GMT+03:00] Europe/Moscow",
        "value": "Europe/Moscow"
    },
    {
        "name": "[GMT+03:00] Europe/Simferopol",
        "value": "Europe/Simferopol"
    },
    {
        "name": "[GMT+03:00] Europe/Volgograd",
        "value": "Europe/Volgograd"
    },
    {
        "name": "[GMT+03:00] Indian/Antananarivo",
        "value": "Indian/Antananarivo"
    },
    {
        "name": "[GMT+03:00] Indian/Comoro",
        "value": "Indian/Comoro"
    },
    {
        "name": "[GMT+03:00] Indian/Mayotte",
        "value": "Indian/Mayotte"
    },
    {
        "name": "[GMT+03:30] Asia/Tehran",
        "value": "Asia/Tehran"
    },
    {
        "name": "[GMT+04:00] Asia/Baku",
        "value": "Asia/Baku"
    },
    {
        "name": "[GMT+04:00] Asia/Dubai",
        "value": "Asia/Dubai"
    },
    {
        "name": "[GMT+04:00] Asia/Muscat",
        "value": "Asia/Muscat"
    },
    {
        "name": "[GMT+04:00] Asia/Tbilisi",
        "value": "Asia/Tbilisi"
    },
    {
        "name": "[GMT+04:00] Asia/Yerevan",
        "value": "Asia/Yerevan"
    },
    {
        "name": "[GMT+04:00] Europe/Astrakhan",
        "value": "Europe/Astrakhan"
    },
    {
        "name": "[GMT+04:00] Europe/Samara",
        "value": "Europe/Samara"
    },
    {
        "name": "[GMT+04:00] Europe/Saratov",
        "value": "Europe/Saratov"
    },
    {
        "name": "[GMT+04:00] Europe/Ulyanovsk",
        "value": "Europe/Ulyanovsk"
    },
    {
        "name": "[GMT+04:00] Indian/Mahe",
        "value": "Indian/Mahe"
    },
    {
        "name": "[GMT+04:00] Indian/Mauritius",
        "value": "Indian/Mauritius"
    },
    {
        "name": "[GMT+04:00] Indian/Reunion",
        "value": "Indian/Reunion"
    },
    {
        "name": "[GMT+04:30] Asia/Kabul",
        "value": "Asia/Kabul"
    },
    {
        "name": "[GMT+05:00] Antarctica/Mawson",
        "value": "Antarctica/Mawson"
    },
    {
        "name": "[GMT+05:00] Asia/Aqtau",
        "value": "Asia/Aqtau"
    },
    {
        "name": "[GMT+05:00] Asia/Aqtobe",
        "value": "Asia/Aqtobe"
    },
    {
        "name": "[GMT+05:00] Asia/Ashgabat",
        "value": "Asia/Ashgabat"
    },
    {
        "name": "[GMT+05:00] Asia/Atyrau",
        "value": "Asia/Atyrau"
    },
    {
        "name": "[GMT+05:00] Asia/Dushanbe",
        "value": "Asia/Dushanbe"
    },
    {
        "name": "[GMT+05:00] Asia/Karachi",
        "value": "Asia/Karachi"
    },
    {
        "name": "[GMT+05:00] Asia/Oral",
        "value": "Asia/Oral"
    },
    {
        "name": "[GMT+05:00] Asia/Qyzylorda",
        "value": "Asia/Qyzylorda"
    },
    {
        "name": "[GMT+05:00] Asia/Samarkand",
        "value": "Asia/Samarkand"
    },
    {
        "name": "[GMT+05:00] Asia/Tashkent",
        "value": "Asia/Tashkent"
    },
    {
        "name": "[GMT+05:00] Asia/Yekaterinburg",
        "value": "Asia/Yekaterinburg"
    },
    {
        "name": "[GMT+05:00] Indian/Kerguelen",
        "value": "Indian/Kerguelen"
    },
    {
        "name": "[GMT+05:00] Indian/Maldives",
        "value": "Indian/Maldives"
    },
    {
        "name": "[GMT+05:30] Asia/Colombo",
        "value": "Asia/Colombo"
    },
    {
        "name": "[GMT+05:30] Asia/Kolkata",
        "value": "Asia/Kolkata"
    },
    {
        "name": "[GMT+05:45] Asia/Kathmandu",
        "value": "Asia/Kathmandu"
    },
    {
        "name": "[GMT+06:00] Antarctica/Vostok",
        "value": "Antarctica/Vostok"
    },
    {
        "name": "[GMT+06:00] Asia/Almaty",
        "value": "Asia/Almaty"
    },
    {
        "name": "[GMT+06:00] Asia/Bishkek",
        "value": "Asia/Bishkek"
    },
    {
        "name": "[GMT+06:00] Asia/Dhaka",
        "value": "Asia/Dhaka"
    },
    {
        "name": "[GMT+06:00] Asia/Omsk",
        "value": "Asia/Omsk"
    },
    {
        "name": "[GMT+06:00] Asia/Qostanay",
        "value": "Asia/Qostanay"
    },
    {
        "name": "[GMT+06:00] Asia/Thimphu",
        "value": "Asia/Thimphu"
    },
    {
        "name": "[GMT+06:00] Asia/Urumqi",
        "value": "Asia/Urumqi"
    },
    {
        "name": "[GMT+06:00] Indian/Chagos",
        "value": "Indian/Chagos"
    },
    {
        "name": "[GMT+06:30] Asia/Yangon",
        "value": "Asia/Yangon"
    },
    {
        "name": "[GMT+06:30] Indian/Cocos",
        "value": "Indian/Cocos"
    },
    {
        "name": "[GMT+07:00] Antarctica/Davis",
        "value": "Antarctica/Davis"
    },
    {
        "name": "[GMT+07:00] Asia/Bangkok",
        "value": "Asia/Bangkok"
    },
    {
        "name": "[GMT+07:00] Asia/Barnaul",
        "value": "Asia/Barnaul"
    },
    {
        "name": "[GMT+07:00] Asia/Ho Chi Minh",
        "value": "Asia/Ho_Chi_Minh"
    },
    {
        "name": "[GMT+07:00] Asia/Hovd",
        "value": "Asia/Hovd"
    },
    {
        "name": "[GMT+07:00] Asia/Jakarta",
        "value": "Asia/Jakarta"
    },
    {
        "name": "[GMT+07:00] Asia/Krasnoyarsk",
        "value": "Asia/Krasnoyarsk"
    },
    {
        "name": "[GMT+07:00] Asia/Novokuznetsk",
        "value": "Asia/Novokuznetsk"
    },
    {
        "name": "[GMT+07:00] Asia/Novosibirsk",
        "value": "Asia/Novosibirsk"
    },
    {
        "name": "[GMT+07:00] Asia/Phnom Penh",
        "value": "Asia/Phnom_Penh"
    },
    {
        "name": "[GMT+07:00] Asia/Pontianak",
        "value": "Asia/Pontianak"
    },
    {
        "name": "[GMT+07:00] Asia/Tomsk",
        "value": "Asia/Tomsk"
    },
    {
        "name": "[GMT+07:00] Asia/Vientiane",
        "value": "Asia/Vientiane"
    },
    {
        "name": "[GMT+07:00] Indian/Christmas",
        "value": "Indian/Christmas"
    },
    {
        "name": "[GMT+08:00] Asia/Brunei",
        "value": "Asia/Brunei"
    },
    {
        "name": "[GMT+08:00] Asia/Choibalsan",
        "value": "Asia/Choibalsan"
    },
    {
        "name": "[GMT+08:00] Asia/Hong Kong",
        "value": "Asia/Hong_Kong"
    },
    {
        "name": "[GMT+08:00] Asia/Irkutsk",
        "value": "Asia/Irkutsk"
    },
    {
        "name": "[GMT+08:00] Asia/Kuala Lumpur",
        "value": "Asia/Kuala_Lumpur"
    },
    {
        "name": "[GMT+08:00] Asia/Kuching",
        "value": "Asia/Kuching"
    },
    {
        "name": "[GMT+08:00] Asia/Macau",
        "value": "Asia/Macau"
    },
    {
        "name": "[GMT+08:00] Asia/Makassar",
        "value": "Asia/Makassar"
    },
    {
        "name": "[GMT+08:00] Asia/Manila",
        "value": "Asia/Manila"
    },
    {
        "name": "[GMT+08:00] Asia/Shanghai",
        "value": "Asia/Shanghai"
    },
    {
        "name": "[GMT+08:00] Asia/Singapore",
        "value": "Asia/Singapore"
    },
    {
        "name": "[GMT+08:00] Asia/Taipei",
        "value": "Asia/Taipei"
    },
    {
        "name": "[GMT+08:00] Asia/Ulaanbaatar",
        "value": "Asia/Ulaanbaatar"
    },
    {
        "name": "[GMT+08:00] Australia/Perth",
        "value": "Australia/Perth"
    },
    {
        "name": "[GMT+08:45] Australia/Eucla",
        "value": "Australia/Eucla"
    },
    {
        "name": "[GMT+09:00] Asia/Chita",
        "value": "Asia/Chita"
    },
    {
        "name": "[GMT+09:00] Asia/Dili",
        "value": "Asia/Dili"
    },
    {
        "name": "[GMT+09:00] Asia/Jayapura",
        "value": "Asia/Jayapura"
    },
    {
        "name": "[GMT+09:00] Asia/Khandyga",
        "value": "Asia/Khandyga"
    },
    {
        "name": "[GMT+09:00] Asia/Pyongyang",
        "value": "Asia/Pyongyang"
    },
    {
        "name": "[GMT+09:00] Asia/Seoul",
        "value": "Asia/Seoul"
    },
    {
        "name": "[GMT+09:00] Asia/Tokyo",
        "value": "Asia/Tokyo"
    },
    {
        "name": "[GMT+09:00] Asia/Yakutsk",
        "value": "Asia/Yakutsk"
    },
    {
        "name": "[GMT+09:00] Pacific/Palau",
        "value": "Pacific/Palau"
    },
    {
        "name": "[GMT+09:30] Australia/Darwin",
        "value": "Australia/Darwin"
    },
    {
        "name": "[GMT+10:00] Antarctica/DumontDUrville",
        "value": "Antarctica/DumontDUrville"
    },
    {
        "name": "[GMT+10:00] Asia/Ust-Nera",
        "value": "Asia/Ust-Nera"
    },
    {
        "name": "[GMT+10:00] Asia/Vladivostok",
        "value": "Asia/Vladivostok"
    },
    {
        "name": "[GMT+10:00] Australia/Brisbane",
        "value": "Australia/Brisbane"
    },
    {
        "name": "[GMT+10:00] Australia/Lindeman",
        "value": "Australia/Lindeman"
    },
    {
        "name": "[GMT+10:00] Pacific/Chuuk",
        "value": "Pacific/Chuuk"
    },
    {
        "name": "[GMT+10:00] Pacific/Guam",
        "value": "Pacific/Guam"
    },
    {
        "name": "[GMT+10:00] Pacific/Port Moresby",
        "value": "Pacific/Port_Moresby"
    },
    {
        "name": "[GMT+10:00] Pacific/Saipan",
        "value": "Pacific/Saipan"
    },
    {
        "name": "[GMT+10:30] Australia/Adelaide",
        "value": "Australia/Adelaide"
    },
    {
        "name": "[GMT+10:30] Australia/Broken Hill",
        "value": "Australia/Broken_Hill"
    },
    {
        "name": "[GMT+11:00] Antarctica/Casey",
        "value": "Antarctica/Casey"
    },
    {
        "name": "[GMT+11:00] Antarctica/Macquarie",
        "value": "Antarctica/Macquarie"
    },
    {
        "name": "[GMT+11:00] Asia/Magadan",
        "value": "Asia/Magadan"
    },
    {
        "name": "[GMT+11:00] Asia/Sakhalin",
        "value": "Asia/Sakhalin"
    },
    {
        "name": "[GMT+11:00] Asia/Srednekolymsk",
        "value": "Asia/Srednekolymsk"
    },
    {
        "name": "[GMT+11:00] Australia/Hobart",
        "value": "Australia/Hobart"
    },
    {
        "name": "[GMT+11:00] Australia/Lord Howe",
        "value": "Australia/Lord_Howe"
    },
    {
        "name": "[GMT+11:00] Australia/Melbourne",
        "value": "Australia/Melbourne"
    },
    {
        "name": "[GMT+11:00] Australia/Sydney",
        "value": "Australia/Sydney"
    },
    {
        "name": "[GMT+11:00] Pacific/Bougainville",
        "value": "Pacific/Bougainville"
    },
    {
        "name": "[GMT+11:00] Pacific/Efate",
        "value": "Pacific/Efate"
    },
    {
        "name": "[GMT+11:00] Pacific/Guadalcanal",
        "value": "Pacific/Guadalcanal"
    },
    {
        "name": "[GMT+11:00] Pacific/Kosrae",
        "value": "Pacific/Kosrae"
    },
    {
        "name": "[GMT+11:00] Pacific/Noumea",
        "value": "Pacific/Noumea"
    },
    {
        "name": "[GMT+11:00] Pacific/Pohnpei",
        "value": "Pacific/Pohnpei"
    },
    {
        "name": "[GMT+12:00] Asia/Anadyr",
        "value": "Asia/Anadyr"
    },
    {
        "name": "[GMT+12:00] Asia/Kamchatka",
        "value": "Asia/Kamchatka"
    },
    {
        "name": "[GMT+12:00] Pacific/Funafuti",
        "value": "Pacific/Funafuti"
    },
    {
        "name": "[GMT+12:00] Pacific/Kwajalein",
        "value": "Pacific/Kwajalein"
    },
    {
        "name": "[GMT+12:00] Pacific/Majuro",
        "value": "Pacific/Majuro"
    },
    {
        "name": "[GMT+12:00] Pacific/Nauru",
        "value": "Pacific/Nauru"
    },
    {
        "name": "[GMT+12:00] Pacific/Norfolk",
        "value": "Pacific/Norfolk"
    },
    {
        "name": "[GMT+12:00] Pacific/Tarawa",
        "value": "Pacific/Tarawa"
    },
    {
        "name": "[GMT+12:00] Pacific/Wake",
        "value": "Pacific/Wake"
    },
    {
        "name": "[GMT+12:00] Pacific/Wallis",
        "value": "Pacific/Wallis"
    },
    {
        "name": "[GMT+13:00] Antarctica/McMurdo",
        "value": "Antarctica/McMurdo"
    },
    {
        "name": "[GMT+13:00] Pacific/Auckland",
        "value": "Pacific/Auckland"
    },
    {
        "name": "[GMT+13:00] Pacific/Enderbury",
        "value": "Pacific/Enderbury"
    },
    {
        "name": "[GMT+13:00] Pacific/Fakaofo",
        "value": "Pacific/Fakaofo"
    },
    {
        "name": "[GMT+13:00] Pacific/Fiji",
        "value": "Pacific/Fiji"
    },
    {
        "name": "[GMT+13:00] Pacific/Tongatapu",
        "value": "Pacific/Tongatapu"
    },
    {
        "name": "[GMT+13:45] Pacific/Chatham",
        "value": "Pacific/Chatham"
    },
    {
        "name": "[GMT+14:00] Pacific/Apia",
        "value": "Pacific/Apia"
    },
    {
        "name": "[GMT+14:00] Pacific/Kiritimati",
        "value": "Pacific/Kiritimati"
    }
]